import { Chip, Divider, Typography } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import EditIcon from '@material-ui/icons/Edit';
import LinkIcon from '@material-ui/icons/Link';
import { WorkItemPicker, WorkItemPreview } from '../WorkItemPicker';
import type { CreationForm } from './creationForm';
import type { CreationMode } from './useCreationBoard';
import { useCreationStyles } from './useCreationStyles';

export function CreationBoardMode({ board, repository }: CreationForm) {
  const classes = useCreationStyles();
  if (!board.enabled || !repository.value.project || !board.canCreateBlank)
    return null;
  return (
    <div className={classes.modeToggle}>
      <ToggleButtonGroup
        value={board.mode}
        exclusive
        size="small"
        onChange={(_e: unknown, val: CreationMode | null) => {
          if (val) board.changeMode(val);
        }}
      >
        <ToggleButton value="work-item">
          <LinkIcon fontSize="small" className={classes.icon} />
          Vincular Card do Board
        </ToggleButton>
        <ToggleButton value="blank">
          <EditIcon fontSize="small" className={classes.icon} />
          Nova Atividade em Branco
        </ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
}

function EmptyWorkItems({ assignedToMe }: { assignedToMe?: boolean }) {
  const classes = useCreationStyles();
  return (
    <div className={classes.emptyState}>
      {assignedToMe ? (
        <>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Nenhum Work Item atribuído a você neste projeto.
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Peça ao seu Analista de Requisitos ou PO para atribuir um item do
            backlog.
          </Typography>
        </>
      ) : (
        <Typography variant="body2" color="textSecondary">
          Nenhum Work Item encontrado. Refine os filtros.
        </Typography>
      )}
    </div>
  );
}

export function CreationBoardSelection({ board, repository }: CreationForm) {
  const classes = useCreationStyles();
  const { selectedWorkItem: selected } = board;
  if (!board.showSection) return null;
  return (
    <div className={classes.wiSection}>
      {selected && (
        <Chip
          icon={<LinkIcon />}
          label={`#${selected.id} — ${selected.type}: ${selected.title}`}
          onDelete={board.clearWorkItem}
          color="secondary"
          className={classes.wiChip}
        />
      )}
      <WorkItemPicker
        projectId={repository.value.project}
        onSelect={board.handleSelectWi}
        selectedId={selected?.id}
        initialFilters={board.initialFilters}
        lockAssignedToMe={!board.canCreateBlank}
        renderEmpty={filters => (
          <EmptyWorkItems assignedToMe={filters.assignedToMe} />
        )}
      />
      {selected && (
        <div className={classes.wiPreview}>
          <WorkItemPreview
            projectId={repository.value.project}
            workItemId={selected.id}
          />
        </div>
      )}
      <Divider className={classes.divider} />
    </div>
  );
}
